import React from 'react';
import {
  LayoutDashboard,
  Building2,
  MapPin,
  BarChart3,
  FileBarChart,
  Users,
  CircleUser,
  Target,
  Download,
  Plus,
} from 'lucide-react';
import { Button } from './button';

const MAIN_LINKS = [
  { icon: LayoutDashboard, label: 'Dashboard', active: true },
  { icon: Building2, label: 'Organisations' },
  { icon: MapPin, label: 'Facilities' },
  { icon: BarChart3, label: 'Usage Data' },
  { icon: FileBarChart, label: 'Reports' },
];

const ACCOUNT_LINKS = [
  { icon: Users, label: 'Users' },
  { icon: CircleUser, label: 'Your Profile' },
  { icon: Target, label: 'Targets' },
];

const ShowcaseSidebarMock = ({ brandName = 'Brand Name', showMetrics = true }) => (
  <div className='rounded-2xl overflow-hidden border border-border shadow-xl'>
    <div className='flex items-center gap-1.5 px-4 py-2.5 bg-muted/30'>
      <div className='w-2.5 h-2.5 rounded-full bg-destructive' />
      <div className='w-2.5 h-2.5 rounded-full bg-warning' />
      <div className='w-2.5 h-2.5 rounded-full bg-success' />
    </div>
    <div className='flex h-[480px]'>
      <div className='w-[220px] bg-sidebar flex-shrink-0 overflow-hidden flex flex-col'>
        <div className='px-6 py-5 border-b border-sidebar-border'>
          <div className='font-display text-sm text-sidebar-foreground'>
            {brandName}
          </div>
          <div className='font-mono text-[9px] text-sidebar-primary mt-0.5 tracking-wider'>PLATFORM</div>
        </div>
        <div className='py-3 flex-1'>
          <div className='font-mono text-[9px] font-bold tracking-[0.18em] uppercase text-sidebar-primary px-5 pb-1.5 pt-3'>
            Main
          </div>
          {MAIN_LINKS.map(({ icon: Icon, label, active }) => (
            <div
              key={label}
              className={`flex items-center gap-2.5 px-5 py-2 text-[13px] font-medium border-l-2 cursor-pointer transition-all ${
                active
                  ? 'text-sidebar-primary border-l-sidebar-primary bg-sidebar-accent'
                  : 'text-sidebar-foreground/60 border-transparent hover:text-sidebar-foreground hover:bg-white/[0.05]'
              }`}>
              <span className='w-4 text-center'>
                <Icon size={14} strokeWidth={1.5} />
              </span>
              <span>{label}</span>
            </div>
          ))}
          <div className='font-mono text-[9px] font-bold tracking-[0.18em] uppercase text-sidebar-primary px-5 pb-1.5 pt-5'>
            Account
          </div>
          {ACCOUNT_LINKS.map(({ icon: Icon, label }) => (
            <div
              key={label}
              className='flex items-center gap-2.5 px-5 py-2 text-[13px] font-medium text-sidebar-foreground/60 border-l-2 border-transparent hover:text-sidebar-foreground hover:bg-white/[0.05] cursor-pointer transition-all'>
              <span className='w-4 text-center'>
                <Icon size={14} strokeWidth={1.5} />
              </span>
              <span>{label}</span>
            </div>
          ))}
        </div>
      </div>
      <div className='flex-1 flex flex-col overflow-hidden bg-background'>
        <div className='bg-card px-5 py-3 border-b border-border flex items-center justify-between'>
          <div>
            <div className='font-display text-lg text-foreground'>Dashboard</div>
            <div className='text-[11px] text-muted-foreground'>Reporting Period: May 2024 — Apr 2025</div>
          </div>
          <div className='flex items-center gap-2'>
            <Button size='sm' variant='outline'>
              <Download size={14} strokeWidth={1.5} className='mr-1.5' /> Export
            </Button>
            <Button size='sm'>
              <Plus size={14} strokeWidth={1.5} className='mr-1.5' /> Add Data
            </Button>
          </div>
        </div>
        {showMetrics && (
          <div className='p-5 flex-1 overflow-hidden'>
            <div className='grid grid-cols-3 gap-3 mb-4'>
              {[
                { v: '12,847', l: 'Total tCO₂e' },
                { v: '24', l: 'Facilities' },
                { v: '-12.3%', l: 'vs. Last Year' },
              ].map(({ v, l }) => (
                <div key={l} className='bg-card rounded-xl p-3.5 border border-border shadow-sm'>
                  <div className='h-0.5 bg-gradient-to-r from-primary to-chart-4 rounded-full mb-2.5' />
                  <div className='font-display text-xl text-foreground leading-none'>{v}</div>
                  <div className='text-[10px] text-muted-foreground mt-1'>{l}</div>
                </div>
              ))}
            </div>
            <div className='bg-card rounded-xl p-4 border border-border shadow-sm'>
              <div className='text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-3'>
                Emissions by Scope
              </div>
              <div className='flex items-end gap-1.5 h-20'>
                {[65, 45, 80, 55, 70, 90, 60, 40, 75, 85, 50, 95].map((h, i) => (
                  <div
                    key={i}
                    className='flex-1 rounded-t min-w-0 bg-muted'
                    style={{ height: `${h}%` }}
                  />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
);

export { ShowcaseSidebarMock };
